import { DatastoreProvider, InstanceStack } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { useLocalSearchParams } from 'expo-router';
import { videoVotingModuleQuery } from 'system/structure-modules';

export default function VideoVotingInstanceLayout() {
    const { siloKey, instanceKey } = useLocalSearchParams<'/[siloKey]/videovoting/[instanceKey]'>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'videovoting',
        instanceKey,
        moduleQuery: videoVotingModuleQuery,
    });
    return (
        <DatastoreProvider {...instanceConfig}>
            <InstanceStack />
        </DatastoreProvider>
    );
}
